<template>
  <v-data-table
    :headers="tableColumnHeaders"
    :items="list"
    item-key="paymentId"
    hide-default-footer
  >
    <!-- isPayment -->
    <template #[`item.isPayment`]="{item}">
      <is-payment :status="item.isPayment" />
    </template>

    <!-- PaymentType -->
    <template #[`item.paymentType`]="{item}">
      <payment-type :status="item.paymentType" />
      <span class="text-xs"><br />{{ item.paymentReference }}</span>
    </template>

    <!-- date -->
    <template #[`item.date`]="{item}">
      <div class="d-flex align-center">
        <div class="d-flex flex-column ms-3">
          <span class="d-block text--primary  font-weight-semibold text-truncate">{{ item.date | date(false, true) }}</span>
          <span class="text-xs">{{ item.note }}</span>
        </div>
      </div>
    </template>

    <!-- total -->
    <template #[`item.amount`]="{item}">
      {{ item.amount | currency }}
    </template>
  </v-data-table>
</template>

<script>
import IsPayment from '@/components/chips/IsPayment.vue'
import PaymentType from '@/components/chips/PaymentType.vue'

export default {
  components: { IsPayment, PaymentType },
  props: {
    list: { type: Array, required: true },
  },
  setup() {
    const tableColumnHeaders = [
      {
        text: '#ID',
        align: 'start',
        value: 'paymentId',
      },
      { text: 'Fecha/Notas', value: 'date' },
      { text: 'Usuario', value: 'user' },
      { text: 'Monto', value: 'amount' },
      { text: 'Pago?', value: 'isPayment' },
      { text: 'Tipo', value: 'paymentType' },
    ]

    return {
      tableColumnHeaders,
    }
  },
}
</script>
